var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { nanoid } from 'nanoid';
import * as R from 'ramda';
import * as F from '../../models/formula.types';
import * as D from '../../models/def.types';
import { XbpmBlockType } from '../../models/xbpm.enums';
import { mapElementTreeAsImmutable, str2Json } from './_.utils';
import { createFormula } from './formula.utils';
var mapElementDefFormulas = function (env, it, path) { return function (fm) {
    return R.pipe(R.pick(F.FORMULA_TYPES_LIST), R.toPairs, R.filter(function (_a) {
        var x = _a[1];
        return !!x;
    }), R.fromPairs, R.evolve(R.fromPairs(F.FORMULA_TYPES_LIST.map(function (key) { return [key, createFormula(key, it, path, env)]; }))))(fm);
}; };
var mapTableRowFormulas = function (parent) { return function () {
    return parent && parent.frontFormulas ? R.pick(F.TABLE_ROW_FORMULA_TYPES_LIST, parent.frontFormulas) : {};
}; };
var assocPropertyDefault = function (target, defaultValue) {
    return R.when(R.pipe(R.path(target), R.anyPass([R.isNil, R.isEmpty])), R.assocPath(target, defaultValue));
};
var assocPropertyFrom = function (from, to, defaultValue) {
    return R.when(R.complement(R.hasPath(to)), R.ifElse(R.hasPath(from), function (it) { return R.assocPath(to, R.path(from, it), it); }, defaultValue !== undefined ? R.assocPath(to, defaultValue) : R.identity));
};
var isXbpmBlock = function (it) { return !!it.blocks || !!it.fields; };
var xbpmItems2Elements = function (it) {
    return R.pipe(R.omit(['blocks', 'fields']), R.assoc('$type', D.ElementDefType.BLOCK), R.assoc('elements', R.sortBy(R.path(['frontOptions', 'order']), __spreadArrays((it.blocks ? it.blocks.map(R.assoc('$type', D.ElementDefType.BLOCK)) : []), (it.fields ? it.fields.map(R.assoc('$type', D.ElementDefType.FIELD)) : [])))))(it);
};
export var mapElementDef = function (env, item, itemParent, id) {
    return mapElementTreeAsImmutable(function (el, parent, path) {
        return R.pipe(
        // map element id
        R.pipe(R.assoc('id', el.id || nanoid(32)), R.assoc('parentId', parent ? parent.id : null)), 
        // defaults
        R.pipe(R.assoc('lastChanged', Date.now()), assocPropertyDefault(['frontOptions'], {}), assocPropertyDefault(['frontFormulas'], {}), 
        // prepare value, hidden, readonly, disabled
        assocPropertyFrom(['defaultValue'], ['value']), assocPropertyFrom(['frontOptions', 'isHidden'], ['hidden']), assocPropertyFrom(['frontOptions', 'isReadOnly'], ['readonly']), assocPropertyFrom(['frontOptions', 'isDisabled'], ['disabled'])), 
        // blocks & fields -> elements
        R.when(isXbpmBlock, xbpmItems2Elements), R.evolve({
            // map front options
            frontOptions: R.pipe(R.omit(['isHidden', 'isReadOnly', 'isDisabled']), R.evolve({
                style: str2Json,
            })),
            // prepare formulas
            frontFormulas: el.kind === XbpmBlockType.TABLE_ROW ? mapTableRowFormulas(parent) : mapElementDefFormulas(env, el, path),
        }))(el);
    })(__assign({ id: id }, item), itemParent);
};
//# sourceMappingURL=raw.utils.js.map